import Cascade from "./KrCascade.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrCascade = install(Cascade); // 生成带有 install 方法的组件

export default KrCascade;
